import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from './configuration';
import ActionsBlock from './ActionsBlock';
import * as NotificationReducer from '../../../../redux/reducers/notification_reducer/selectors';
import { useDispatch } from 'react-redux';
import NotificationActions from '../../../../redux/reducers/notification_reducer/actions';
import { Box } from '@material-ui/core';
import useStyles from './styles';
import useQuery from 'custom_hooks/useQuery';
import { useHistory } from 'react-router';
import NavigationConfig from 'navigation/config';
import { NotificationTableDefaultFetchValues } from './configuration';

export default function DatatableList() {
  const result = NotificationReducer.useGetNotificationList();
  const dispatch = useDispatch();
  const classes = useStyles();
  const query = useQuery();
  const history = useHistory();
  const sortField: string = query.get('notificationSortField')
    ? (query.get('notificationSortField') as string)
    : NotificationTableDefaultFetchValues.TABLE_DEFAULT_SORT_KEY;
  const order: 'asc' | 'desc' = query.get('notificationOrder')
    ? (query.get('notificationOrder') as 'asc' | 'desc')
    : NotificationTableDefaultFetchValues.TABLE_DEFAULT_ORDER;
  const vatNumber = query.get('notificationVatNumber');
  const notificationType = query.get('notificationType');
  const notificationDateFrom = query.get('notificationDateFrom');
  const notificationDateTo = query.get('notificationDateTo');
  const notificationPaging = result.data?.paging;
  const paging = {
    pageSize: notificationPaging
      ? notificationPaging.pageSize
      : NotificationTableDefaultFetchValues.TABLE_DEFAULT_PAGE_SIZE,
    page: notificationPaging
      ? notificationPaging.page
      : NotificationTableDefaultFetchValues.TABLE_DEFAULT_PAGE,
    total: notificationPaging ? notificationPaging.total : 0,
  };
  return (
    <Box display="flex" flexDirection="column">
      {/* <Button
        onClick={() =>
          dispatch(
            ModalActions.openModalAction({
              modalID: ModalIDs.MODAL_ADD_EDIT_NOTIFICATION,
              params: { type: 'add' },
            })
          )
        }
        className={classes.addButton}
      >
        Add Record
      </Button> */}
      <Datatable
        loading={true}
        sorting={{
          sortField: sortField,
          order: order,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(
          selectedPage,
          pageSize,
          nextOrder,
          nextSortField
        ) => {
          const nextParams = new URLSearchParams(query.toString());
          nextParams.set('notificationSortField', nextSortField);
          nextParams.set('notificationPage', `${selectedPage}`);
          nextParams.set('notificationPageSize', `${pageSize}`);
          nextParams.set('notificationOrder', nextOrder);
          dispatch(
            NotificationActions.fetchNotificationListAction({
              sortField: nextSortField,
              page: selectedPage,
              pageSize: pageSize,
              order: nextOrder,
              vatNumber: vatNumber,
              notificationType: notificationType,
              notificationDateFrom: notificationDateFrom,
              notificationDateTo: notificationDateTo,
            })
          );
          history.push(
            NavigationConfig.notificationsPage().path +
              `?${nextParams.toString()}`
          );
        }}
      />
    </Box>
  );
}

export { ActionsBlock };
